import React from "react";

import type { WithContentTypeAndDateProps } from "../../../../lib/modules/listSearchUtils/index.d";
import Base from "../Base/Base";

export default function WithContentTypeAndDate(props: Readonly<WithContentTypeAndDateProps>) {
  const {
    contentTypeDisplayname,
    date,
    dateDescription
  } = props;

  return (
    <Base {...props}>
      { (contentTypeDisplayname) && <p className="text-neutral-subtle">{contentTypeDisplayname}</p> }
      { date
        && (
          <div className="flex flex-row">
            { dateDescription && <span className="mr-xxs">{dateDescription}</span> }
            <time dateTime={date}>{date}</time>
          </div>
        )}
    </Base>
  );
}
